import React from "react";
import AlumniSchool from "../Alumni/Models/AlumniSchool";

interface Props {
  collegeSchools: AlumniSchool[];
}

export default function AlumniSection({ collegeSchools }: Props) {
  return (
    <>
      <div className="careers-alum">
        <div className="careers-alum-title">
          <h3 className="careers-alum__title">Alumni Careers</h3>
          <p className="careers-alum__subtitle">
            We work with colleges and universities to offer internships and job
            opportunities. Check out what some of your alumni have to say!
          </p>
        </div>
        <div className="careers-alum-container clearfix">
          {collegeSchools.map(
            ({ name, className, imageGraySrc, imageWhiteSrc, imageAlt }) => {
              return (
                <a
                  href={`/careers/alumni/${name}/`}
                  className={`careers-alum-block ${className}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={name}
                >
                  <img
                    src={imageGraySrc}
                    alt={imageAlt}
                    className="careers-alum__block-image careers-alum__block-image--gray"
                  />
                  <img
                    src={imageWhiteSrc}
                    alt={imageAlt}
                    className="careers-alum__block-image careers-alum__block-image--white"
                  />
                </a>
              );
            }
          )}
        </div>
      </div>
      <div id="gdprBannerMount" />
    </>
  );
}
